export default __webpack_public_path__ + "static/Natural_Light_Outdoor_320kbps-ab589dd6cc5b941faefcccf388106e2f.avif";